module.exports = __webpack_public_path__ + "578dcfa075f2ebceff989169f404facc.png";